import { Button, type ButtonProps } from '@mui/material';
import { useIsMobile } from '@side/pantry';

export const ExportToCSVButton = (props: ButtonProps) => {
  const isMobile = useIsMobile('md');

  return (
    <Button
      variant="outlined"
      color="utility"
      size={isMobile ? 'small' : 'medium'}
      {...props}
    >
      {isMobile ? 'Export' : 'Export to CSV'}
    </Button>
  );
};
